export const ORDER_STATES = {
    SHIPPED: "Shipped",
    DELIVERED: "Delivered",
    PENDING: "Pending",
    PROCESSING: "Processing",
    CANCELED: "Canceled",
} as const;

export const PAYMENT_METHODS = {
    BANK_TRANSFER: "Bank Transfer",
    CONNECTED_PAYMENT: "connected-payment-method",
    CREDIT_CARD: "Credit Card",
    PAYPAL: "PayPal",
} as const;

export const PAYMENT_STATES = {
    SETTLED: "Settled",
    AUTHORIZED: "Authorized",
    CREATED: "Created",
    DECLINED: "Declined",
    ERROR: "Error",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
    PARTIALLY_REFUNDED: "PartiallyRefunded",
} as const;

export const NO_IMAGE_PLACEHOLDER = "assets/icons/venduro-icon-light-grey.svg";
export const SUPPORT_EMAIL = "support@venduro.io";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const CHECKOUT_PATH = "checkout";
export const CHECKOUT_PAYMENT_PATH = "payment";
export type OrderState = (typeof ORDER_STATES)[keyof typeof ORDER_STATES];
export type PaymentMethod =
    (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS];
export type PaymentState = (typeof PAYMENT_STATES)[keyof typeof PAYMENT_STATES];

export const AUTH_TOKEN_KEY = "auth_token";

export const ERROR_SIGN_IN_REQUIRED = "You need to be signed in";


